import { render, staticRenderFns } from "./AccountTriggerActivationMail.vue?vue&type=template&id=2f09f7e5&scoped=true"
import script from "./AccountTriggerActivationMail.vue?vue&type=script&lang=ts"
export * from "./AccountTriggerActivationMail.vue?vue&type=script&lang=ts"
import style0 from "./AccountTriggerActivationMail.vue?vue&type=style&index=0&id=2f09f7e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f09f7e5",
  null
  
)

/* custom blocks */
import block0 from "./activation.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc207775979%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Faccount-activation%2FAccountTriggerActivationMail.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./activation.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc207775979%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Faccount-activation%2FAccountTriggerActivationMail.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports